module.exports = __webpack_public_path__ + "img/file_excel.5b4f4cfe.png";